import React from "react";
import { Modal, Button, Badge, Row, Col } from "react-bootstrap";
import moment from "moment";
import capitalize from "../../../../../capitalize";

const STATUS_VARIANT = {
  pending: "warning",
  approved: "success",
  retired: "secondary",
  declined: "danger",
};

const ViewModal = ({ show, onHide, impress }) => {
  if (!impress) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>Imprest Details</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 16,
          }}
        >
          <h6 style={{ margin: 0, fontWeight: 600 }}>{capitalize(impress.name)}</h6>
          <Badge variant={STATUS_VARIANT[impress.status] || "secondary"} pill style={{ padding: "5px 10px" }}>
            {capitalize(impress.status)}
          </Badge>
        </div>

        <Row style={{ marginBottom: 12 }}>
          <Col xs={6}>
            <small style={{ color: "#6b7280" }}>Type</small>
            <p style={{ margin: 0, fontWeight: 500 }}>{capitalize(impress.type)}</p>
          </Col>
          <Col xs={6}>
            <small style={{ color: "#6b7280" }}>Amount</small>
            <p style={{ margin: 0, fontWeight: 500 }}>
              ₦{Number(impress.amount).toLocaleString()}
            </p>
          </Col>
        </Row>

        <Row style={{ marginBottom: 12 }}>
          <Col xs={6}>
            <small style={{ color: "#6b7280" }}>Function</small>
            <p style={{ margin: 0, fontWeight: 500 }}>{capitalize(impress.function)}</p>
          </Col>
          <Col xs={6}>
            <small style={{ color: "#6b7280" }}>Date</small>
            <p style={{ margin: 0, fontWeight: 500 }}>
              {moment(impress.date).format("DD MMM YYYY")}
            </p>
          </Col>
        </Row>

        <div style={{ marginBottom: 12 }}>
          <small style={{ color: "#6b7280" }}>Description</small>
          <p style={{ margin: 0 }}>{capitalize(impress.description)}</p>
        </div>

        {impress.proof && (
          <div>
            <small style={{ color: "#6b7280" }}>Proof of Retirement</small>
            <div style={{ marginTop: 6 }}>
              <img
                src={impress.proof}
                alt="Proof"
                style={{
                  width: "100%",
                  borderRadius: 8,
                  border: "1px solid #e5e7eb",
                }}
              />
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} size="sm">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewModal;